import { rankingItems } from '@/mocks/home';

const rankMedals: Record<number, string> = {
  1: 'text-secondary-500',
  2: 'text-foreground-300',
  3: 'text-accent-500',
};

export default function RankingSection() {
  return (
    <section id="ranking" className="px-4 md:px-6 py-14 md:py-20 bg-background-50">
      <div className="max-w-3xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">热门榜单</h2>
          <p className="mt-2 text-sm text-foreground-500">51大赛热门内容排行</p>
        </div>

        <div className="bg-background-100 rounded-2xl border border-background-200/70 overflow-hidden">
          {rankingItems.map((item, index) => (
            <div
              key={index}
              className={`flex items-center gap-4 px-5 py-4 cursor-pointer hover:bg-background-50 transition-colors ${
                index < rankingItems.length - 1 ? 'border-b border-background-200/70' : ''
              }`}
            >
              <div className={`w-8 h-8 flex items-center justify-center flex-shrink-0 ${rankMedals[item.rank] || 'text-foreground-400'}`}>
                {item.rank <= 3 ? (
                  <i className="ri-medal-fill text-lg"></i>
                ) : (
                  <span className="text-sm font-bold">{item.rank}</span>
                )}
              </div>

              <div className="flex-1 min-w-0">
                <p className="text-sm font-semibold text-foreground-900 truncate">{item.title}</p>
                <div className="flex items-center gap-2 mt-0.5">
                  <span className="text-xs text-foreground-400">{item.views} 次播放</span>
                </div>
              </div>

              <div className={`flex items-center gap-1 text-xs font-medium flex-shrink-0 ${
                item.trend === 'up' ? 'text-accent-600' : 'text-foreground-400'
              }`}>
                <i className={`text-xs ${item.trend === 'up' ? 'ri-arrow-up-s-line' : 'ri-arrow-down-s-line'}`}></i>
                <span>{item.change}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}